import { Grid, Typography } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import * as React from "react";
import { useEffect } from "react";
import { Button, useGetOne, useRefresh } from "react-admin";
import sendRequest from "../../dataProvider/sendRequest";
import CustomButtonCancel from "../../unit/CustomButtonCancel";
import CustomButtonSubmit from "../../unit/CustomButtonSubmit";
import CustomDialogTitle from "../../unit/CustomDialogTitle";
import HeaderLabelTitle from "../../unit/HeaderLabelTitle";
import HeaderLabelValue from "../../unit/HeaderLabelValue";
import formatCurrency from "../../unit/formatCurrency";
import CustomSelect from "../../unit/forms/CustomSelect";
import useNotify from "../../unit/useNotify";
import DialogApplicationBaseInfo from "../DialogApplicationBaseInfo";
import CustomApplicationDialogTitle from "./CustomApplicationDialogTitle";
import CustomControlMoneyEditTextField from "../../unit/forms/CustomControlMoneyEditTextField";

export default function CustomProceedFormDialog({ ...props }) {
  const { successNotify, errorNotify, infoNotify } = useNotify();
  const { appId, record } = props;
  const [open, setOpen] = React.useState(false);
  const [isFirstView, setIsFirstView] = React.useState(0);
  let defaultTerm = record?.termSubmit;

  // if (record?.termReview) {
  //   defaultTerm = record?.termReview;
  // }
  // if (record?.loan && record?.loan?.noteTerm) {
  //   defaultTerm = record?.loan?.noteTerm;
  // }
  const [loanAmount, setLoanAmount] = React.useState<any>(
    record?.amountRecommendation || record?.amountSubmit
  );
  const [termRecommendation, setTermRecommendation] = React.useState(
    record?.termRecommendation
      ? parseInt(record?.termRecommendation)
      : defaultTerm
  );

  let defaultRate = record?.rateRecommendation;
  // if (record?.loan && record?.loan?.interestRate) {
  //   defaultRate = record?.loan?.interestRate;
  // }
  if (defaultRate == "0.00") {
    defaultRate = 0;
  }
  const [rateRecommendation, setRateRecommendation] = React.useState(
    defaultRate || 0
  );
  const refresh = useRefresh();
  const { data, isLoading, error } = useGetOne(
    "applications/actions/review/checkMultipleReview",
    {
      id: appId,
    }
  );
  useEffect(() => {
    if (data) {
      setIsFirstView(data.isFirstView);
    }
  }, [data]);
  if (error) {
    errorNotify("Error loading Application " + error);
  }
  if (isLoading) {
    return <Typography>Application List Loading</Typography>;
  }

  const handleInputChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = event.target;
    if (name === "loanamount") {
      setLoanAmount(value);
    }
  };
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    refresh();
  };

  const formatRate = (num: any) => {
    if (num == "" || num == null || num == 0) {
      return "0.00%";
    } else {
      return num + "%";
    }
  };
  const defautRateOptionList: { label: string; value: any }[] = [];
  defautRateOptionList.push({ label: "Select", value: "" });
  if (record.rateData) {
    for (let i = 0; i < Object.keys(record.rateData).length; i++) {
      defautRateOptionList.push({
        label: formatRate(record.rateData[i]),
        value: record?.rateData[i] == undefined ? "0.00" : record?.rateData[i],
      });
    }
  }

  const defautTermsList = [];
  defautTermsList.push({ label: "Select", value: "" });
  if (record.termsData) {
    for (let i = 0; i < record.termsData.length; i++) {
      defautTermsList.push({
        label: record.termsData[i],
        value: record.termsData[i],
      });
    }
  }

  const defautPaymentFreqList = [];
  if (record.paymentFrequencyData) {
    for (let i = 0; i < record.paymentFrequencyData.length; i++) {
      defautPaymentFreqList.push({
        label: record.paymentFrequencyData[i].name,
        value: record.paymentFrequencyData[i].bbkey,
      });
    }
  }

  const defaultOverrideList = [
    { label: "Approved", value: "Approved" },
    { label: "Countered", value: "Countered" },
    { label: "Declined", value: "Declined" },
  ];

  return (
    <React.Fragment>
      <Button
        id="btn-application-proceed"
        label="Proceed"
        variant="contained"
        size="medium"
        color="primary"
        sx={{ marginLeft: "10px", width: "120px" }}
        onClick={() => {
          const firstView = handleClickOpen(appId);
          setIsFirstView(firstView);
          setOpen(true);
        }}
      />
      <Dialog
        id="dialog-application-proceed"
        open={open}
        onClose={handleClose}
        fullWidth={true}
        maxWidth="md"
        PaperProps={{
          component: "form",
          onSubmit: async (event: React.FormEvent<HTMLFormElement>) => {
            event.preventDefault();
            const formData = new FormData(event.currentTarget);
            const formJson = Object.fromEntries((formData as any).entries());
            const notes = formJson.notes;

            const reqUrl = `applications/actions/review/proceed`;
            const response = await sendRequest(reqUrl, {
              id: appId,
              data: formJson,
            });

            if (response && response.status == "200") {
              successNotify("Data saved successfully");
              handleClose();
              if (props.cb) {
                props.cb("To Notify");
              }
            } else {
              errorNotify(response?.message || "Data not saved!");
            }
          },
        }}
      >
        <DialogTitle
          sx={{
            borderBottom: "1px solid #e5e5e5",
            mb: 2,
          }}
        >
          <CustomApplicationDialogTitle record={record} subTitle="Proceed" />
        </DialogTitle>
        <DialogContent>
          <DialogContentText></DialogContentText>
          <DialogApplicationBaseInfo appId={appId} record={record} />
          <Grid container sx={{ mb: 2, pb: 2 }}>
            <Grid item xs={12} sx={{ mb: 2 }}>
              <Typography variant="h6" gutterBottom>
                Recommendation :&nbsp;
                {record.sRecommendation ? record.sRecommendation : ""}
              </Typography>
            </Grid>
            {(record.sRecommendation == "approve" ||
              record.sRecommendation == "Approved" ||
              record.sRecommendation == "pre-approved" ||
              record.sRecommendation == "pre-approve" ||
              record.sRecommendation == "Pre-Approved" ||
              record.sRecommendation == "counter" ||
              record.sRecommendation == "Countered") && (
              <>
                <Grid item xs={12} container>
                  <Grid item xs={3} sx={{ pt: 1 }}>
                    <HeaderLabelTitle title="Recommended Amount" />
                  </Grid>
                  {record.sSubType != "securedcreditcard" && (
                    <>
                      <Grid item xs={3} sx={{ pt: 1 }}>
                        <HeaderLabelTitle title="Recommended Term" required />
                      </Grid>
                      <Grid item xs={3} sx={{ pt: 1 }}>
                        <HeaderLabelTitle title="Interest Rate" required />
                      </Grid>
                    </>
                  )}
                </Grid>

                <Grid item xs={12} spacing={1} container>
                  <Grid item xs={3} sx={{ pt: 2 }}>
                    {/* <HeaderLabelValue
                      value={formatCurrency(
                        record.amountRecommendation
                          ? record.amountRecommendation
                          : record.amountSubmit
                      )}
                    /> */}
                    <CustomControlMoneyEditTextField
                      name="loanamount"
                      defaultValue={loanAmount}
                      min={record?.minAmountData}
                      max={record?.maxAmountData}
                      readonly={true}
                      onChange={handleInputChange}
                      required={true}
                      prefix={false}
                      helperText="no"
                      className="amountText"
                    />
                  </Grid>
                  {record.sSubType != "securedcreditcard" && (
                    <>
                      {/* {termRecommendation}--{record?.termRecommendation} */}
                      <Grid item xs={3} sx={{ pt: 1 }}>
                        <CustomSelect
                          fullWidth={true}
                          variant="outlined"
                          id="term"
                          name="term"
                          value={termRecommendation}
                          onChange={(e) => {
                            setTermRecommendation(e.target.value);
                          }}
                          optionlist={defautTermsList}
                          required={true}
                        />
                      </Grid>
                      <Grid item xs={3} sx={{ pt: 1 }}>
                        <CustomSelect
                          fullWidth={true}
                          variant="outlined"
                          id="rate"
                          name="rate"
                          value={rateRecommendation}
                          onChange={(e) => {
                            setRateRecommendation(e.target.value);
                          }}
                          optionlist={defautRateOptionList}
                          required={true}
                        />
                      </Grid>
                    </>
                  )}
                </Grid>
              </>
            )}

            {/* <Grid sx={{ mb: 2, mt: 2 }} container>
              <HeaderLabelTitle title="Add Note (Max 150 Characters)" />
            </Grid>
            <Grid sx={{ mb: 0 }} container>
              <TextField
                autoFocus
                required
                id="notes"
                name="notes"
                placeholder="Notes"
                multiline={true}
                minRows={3}
                fullWidth
                variant="outlined"
              />
            </Grid> */}
          </Grid>
          {record.rationale && (
            <Grid container>
              <HeaderLabelTitle title="Rationale" />
              <HeaderLabelValue value={record.rationale} />
            </Grid>
          )}

          {isFirstView != 1 && (
            <Grid sx={{ mb: 2, mt: 0, color: "red" }} container>
              Click on "Proceed" button below to confirm Application {appId} is
              ready for execution. This application will then be moved to "To
              Notify Applicants" page in the Applications drop down menu.
            </Grid>
          )}
        </DialogContent>
        <DialogActions sx={{ justifyContent: "space-between" }}>
          <CustomButtonCancel onClick={handleClose} />
          <CustomButtonSubmit label="Proceed" />
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
